<div class="country-selector">
    @if(forms.allCountries.length && settings.selectedModule !== undefined) {
        <button class="country-button" (click)="setCountry($event)">
            @if(settings.selectedModule?.country) {
                <div>
                    <span class="country-flag {{ countryInitial }}"></span>
                    <span class="label">{{ settings.selectedModule?.country }}</span>
                </div>
            } @else {
                <div class="placeholder-text">{{ subtitle(1929) }}</div>
            }
            <img class="invert" ngSrc="/assets/img/icons/drop-down-arrow.svg"
                 width="12" height="12" alt="">
        </button>
        @if (forms.showModuleCountry[settings.selectedModule.id]?.show) {
            <ul class="country-list">
                @for(country of forms.allCountries; track country.name){
                    <li class="country-list-item" (click)="changeCountry(country)">
                        <div class="country-flag {{ country.initial }}"></div>
                        <div class="flex-1">{{ country.name }}</div>
                    </li>
                }
            </ul>
        }
    }
</div>
